import { IAppState } from '../../../../../AppModulesWrapper';

export const selectRecommendedPackagesAutoprolong = (state: IAppState): boolean => {
  return state.servicePickerWidgetV2.recommendedPackages.checkoutModalData.autoprolong;
};
